import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import expandIcon from "../../assests/page/chevron-right.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import walletIcon from "../../assests/page/Key.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import copyIcon from "../../assests/page/copy_icon.svg";
import verifiedIcon from "../../assests/page/verified-checkmark.svg";
import React, { useState } from "react";
import { getUserKYCDetails } from "../../services/contracts/clientContract";
import Avatar from "react-avatar";
import { useGetSupportedCurrencies } from "../../hooks/currencies";
import { sendFunds } from "../../services/contracts/tokens";
import { ethers } from "ethers";
import SuccessPopup from "./success";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { errorToast } from "../../utils/constants";
import AddFunds from "./addFunds";
import { createMeeClient } from "@biconomy/abstractjs";
import { ERC20 } from "@verified-network/verified-sdk";
import PaymentProcess from "./paymentProcess";
import { useAppKit } from "@reown/appkit/react";
import GeneralPopupBackground from ".";
import { authenticateKYCStatus } from "../../utils/helpers/kyc";
import {
  authenticatePaymentToken,
  extractNumberWithCommas,
  getAllVerifiedCashBalances,
  showCustomAlert,
} from "../../utils/helpers/utils";
import { useTranslation } from "react-i18next";

const SendFunds = (props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState(0);
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState({
    countryName: "India",
    officialName: "India",
    flag: "",
    currencySymbol: "INR",
    currencyName: "Indian Rupee",
    officialCurrencySymbol: "₹",
    isClicked: false,
    tokenAddress: "",
  });

  const [newSearchContent, setNewSearchContent] = useState(null);
  const [step, setStep] = useState(props?.step || "1");
  const [receiver, setReceiver] = useState({ userFullName: "" });
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [customPopupContent, setCustomPopupContent] = useState(null);
  const [customPopupPosition, setCustomPopupPosition] = useState("");

  const { chainId, provider, signer, web3, nexusAccount } = useNetworkStore();
  const { userAddress } = useUserStore();

  const appKitModal = useAppKit();

  const {
    verifiedWalletDetails,
    custodyWalletDetails,
    setVerifiedWalletDetails,
  } = props.generalDataProps;

  const { getSupportedCurrenciesData, getSupportedCurrenciesLoading } =
    useGetSupportedCurrencies(props?.addFundsAction);

  const handleChooseCurrencyButtonDisplay = () => {
    const button = document.getElementById("convert-currency-popup-button");
    if (button && selectedCurrency.isClicked) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  const handleSendFunds = async () => {
    // authenticate kyc
    setCustomPopupPosition("flex-end");
    setCustomPopupContent(<PaymentProcess title={"Checking KYC status"} />);
    setShowCustomPopup(true);
    await authenticateKYCStatus(
      chainId,
      userAddress,
      web3,
      appKitModal,
      props.setPopupContent,
      props.setPopupContentPosition,
      props.setShowPopup,
      props.setCustomLoading,
      props.setFavouriteClicked,
      false,
      setVerifiedWalletDetails,
      verifiedWalletDetails,
      props.generalDataProps,
    ).then(async (res) => {
      if (!res) {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Oops Something went wrong",
          "Unexpected error. Try again later",
        );
        return;
      }
      if (receiver?.userAddress?.toLowerCase() === userAddress?.toLowerCase()) {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Recipient is the same as sender",
          "Recipient address can not be your address.",
        );
        return;
      }
      if (Number(amount) <= 0) {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Invalid amount",
          "Amount cannot be lesser or equal to zero(0)",
        );
        return;
      }
      if (Number(selectedCurrency?.balance) < Number(amount)) {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Insufficient balance",
          "Amount cannot be greater than your balance",
        );
        return;
      }
      if (
        receiver?.userAddress.length > 0 &&
        chainId &&
        signer &&
        web3 &&
        provider
      ) {
        const amountInWei = ethers.utils.parseUnits(
          amount?.toString(),
          Number(selectedCurrency?.tokenDecimals),
        );
        const tokenContractVer = new ERC20(
          signer,
          selectedCurrency?.tokenAddress,
        );

        let paymentToken;
        const helpers = {
          setSelectedCurrency,
          setAmount,
          setPopupContent: props.setPopupContent,
          setPopupContentPosition: props.setPopupContentPosition,
          setShowPopup: props.setShowPopup,
          setFavouriteClicked: props.setFavouriteClicked,
          customLoading: props.customLoading,
          setCustomLoading: props.setCustomLoading,
          generalDataProps: props.generalDataProps,
          setCustomPopupPosition: setCustomPopupPosition,
          setCustomPopupContent: setCustomPopupContent,
          setShowCustomPopup: setShowCustomPopup,
        };
        if (
          selectedCurrency?.tokenAddress?.toLowerCase() !==
          ethers.constants.AddressZero?.toLowerCase()
        ) {
          paymentToken = await authenticatePaymentToken(
            chainId,
            userAddress,
            web3,
            verifiedWalletDetails,
            tokenContractVer,
            "transfer",
            [receiver?.userAddress, amountInWei],
            helpers,
            false,
          );
        } else if (
          selectedCurrency?.tokenAddress?.toLowerCase() ===
            ethers.constants.AddressZero?.toLowerCase() &&
          nexusAccount
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            userAddress,
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setCustomPopupPosition("flex-end");
            setCustomPopupContent(
              <SuccessPopup
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                isCustom={true}
                customTextHeader="Transaction Failed!"
                customTextFooter="Something went wrong"
                setFavouriteClicked={props.setFavouriteClicked}
                isError={true}
                setCustomPopupPosition={setCustomPopupPosition}
                setCustomPopupContent={setCustomPopupContent}
                setShowCustomPopup={setShowCustomPopup}
              />,
            );
            setShowCustomPopup?.(true);
            errorToast(
              "Unexpected Error",
              "No valid Cash Token on this network. Change network and try again.",
            );

            return;
          }
          paymentToken = cashTokens[0];
          const meeClient = await createMeeClient({
            account: nexusAccount,
            apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
          });

          const transactionInstruction = await nexusAccount.build({
            type: "default",
            data: {
              chainId,
              calls: [
                {
                  chainId: chainId,
                  to: receiver?.userAddress,
                  value: amountInWei,
                  data: "0x",
                },
              ],
            },
          });

          const quote = await meeClient.getQuote({
            instructions: [transactionInstruction],
            feeToken: {
              address: cashTokens[0]?.address,
              chainId: chainId,
            },
          });

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(quote?.paymentInfo?.tokenAmount) >
              Number(cashTokens[0]?.balance)
          ) {
            setCustomPopupPosition("flex-end");
            setCustomPopupContent(
              <SuccessPopup
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                isCustom={true}
                customTextHeader="Transaction Failed!"
                customTextFooter={`Insufficient ${cashTokens[0]?.name} to pay for transaction`}
                setFavouriteClicked={props.setFavouriteClicked}
                isError={true}
                setCustomPopupPosition={setCustomPopupPosition}
                setCustomPopupContent={setCustomPopupContent}
                setShowCustomPopup={setShowCustomPopup}
                showButton={true}
                buttonText={`Topup ${cashTokens[0]?.name}`}
                buttonFunc={() => {
                  const input = document.getElementById(
                    "add-funds-popup-input",
                  );
                  if (input) {
                    input.value = "";
                  }
                  setSelectedCurrency({
                    countryName: "",
                    officialName: "",
                    flag: null,
                    currencySymbol: "",
                    currencyName: "",
                    officialCurrencySymbol: "",
                    isClicked: false,
                    balance: 0.0,
                    isCrypto: true,
                  });
                  setAmount("");

                  props.setPopupContent(null);
                  props.setPopupContentPosition("flex-end");
                  props.setPopupContent(
                    <AddFunds
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      customLoading={props.customLoading}
                      setCustomLoading={props.setCustomLoading}
                      generalDataProps={props.generalDataProps}
                      addFundsAction="add-funds"
                    />,
                  );
                  props.setShowPopup(true);
                }}
              />,
            );
            setShowCustomPopup?.(true);
            errorToast(
              `Insufficient ${cashTokens[0]?.name} balance`,
              `You need at least: ${quote?.paymentInfo?.tokenAmount}  ${cashTokens[0]?.name} to proceed.`,
            );
          }
        }
        await sendFunds(
          chainId,
          provider,
          signer,
          selectedCurrency?.tokenAddress,
          userAddress,
          receiver?.userAddress,
          amountInWei?.toString(),
          amount?.toString(),
          paymentToken,
          web3,
          custodyWalletDetails,
          verifiedWalletDetails,
          nexusAccount,
          helpers,
        ).then((res) => {
          if (res) {
            setCustomPopupPosition("center");
            setCustomPopupContent(null);
            setShowCustomPopup(false);
            props.setPopupContent(
              <SuccessPopup
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                isCustom={true}
                customTextHeader="Congratulations!"
                customTextFooter={`You have successfully sent funds to recipient's account`}
                setFavouriteClicked={props.setFavouriteClicked}
              />,
            );
            props.setPopupContentPosition("flex-end");
            props.setShowPopup(true);
          }
        });
      } else {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Oops Something went wrong",
          "Unexpected error. Try again later",
        );
        return;
      }
    });
  };

  return (
    <React.Fragment>
      {showCustomPopup && (
        <GeneralPopupBackground
          popupContent={customPopupContent}
          popupContentPosition={
            customPopupPosition !== "" ? customPopupPosition : "center"
          }
        />
      )}

      <div className="add-funds-popup">
        {!showAllCurrencies && (
          <div
            style={{ overflowX: "hidden", overflowY: "auto" }}
            className="add-funds-content"
          >
            <div className="add-funds-content-header">
              <div className="add-funds-content-header-text-container">
                {step !== "1" && (
                  <img
                    className="profile-popup-icon"
                    onClick={() => {
                      setStep(String(Number(step) - 1));
                      setReceiver({});
                      setSelectedCurrency({ tokenAddress: "" });
                    }}
                    alt="Close Icon"
                    src={backIcon}
                  />
                )}
                <p className="add-funds-content-header-text">
                  {t("sendFunds.sendFunds")}
                </p>
              </div>
              <img
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  setNewSearchContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                }}
                className="add-funds-popup-close-icon"
                alt="Close Icon"
                src={popupCloseIcon}
              />
            </div>

            <div className="send-funds-inner-div">
              {Number(step) < 3 && (
                <div className="send-funds-inner-div-container">
                  <p className="send-funds-inner-div-text">
                    {t("sendFunds.whomAreYouSendingTo")}
                  </p>
                </div>
              )}

              <div className="send-funds-inner-div-second">
                <div className="send-funds-inner-div-second-container">
                  {step === "1" && (
                    <div
                      onClick={() => {
                        setStep("2");
                      }}
                      className="send-funds-inner-div-second-content"
                    >
                      <div className="send-funds-inner-div-second-content-inner">
                        <div className="send-funds-inner-div-second-content-icon">
                          <img src={walletIcon} alt="wallet icon" />
                        </div>

                        <p className="send-funds-inner-div-second-content-text">
                          {t("sendFunds.enterWalletAddress")}
                        </p>
                      </div>
                    </div>
                  )}
                  {step === "2" && (
                    <div className="send-funds-inner-div-second-content-input">
                      <input
                        onInput={async (e) => {
                          if (
                            chainId &&
                            e.target.value?.length === 42 &&
                            provider?.getSigner(e.target.value)
                          ) {
                            await getUserKYCDetails(
                              chainId,
                              e.target.value,
                              provider?.getSigner(e.target.value),
                            ).then((res) => {
                              setReceiver({
                                userAddress: e.target.value,
                                ...res,
                              });
                            });
                          } else if (e.target.value?.length === 42) {
                            setReceiver({
                              userFullName: "",
                              userAddress: e.target.value?.length,
                            });
                          } else {
                            setReceiver({});
                          }
                        }}
                        className="send-funds-inner-div-second-input"
                        type="text"
                        placeholder={t("placeholder.walletAddress")}
                      />
                    </div>
                  )}
                </div>
              </div>

              {step === "2" && receiver?.userAddress && (
                <div
                  onClick={() => {
                    setStep("3");
                  }}
                  className="send-funds-step2-inner-div"
                >
                  <div className="send-funds-step2-inner-div-container">
                    <div className="send-funds-step2-inner-div-icon">
                      <Avatar name={receiver?.userFullName} />
                    </div>

                    <div className="send-funds-step2-inner-text">
                      <p className="send-funds-step2-inner-title">
                        {receiver?.userFullName}
                      </p>
                      <p className="send-funds-step2-inner-label">
                        {receiver?.userAddress}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {step === "3" && (
              <div className="send-funds-step3-outter-div-cont">
                <div className="send-funds-step3-outter-div">
                  <div className="send-funds-step3-outter-div-content">
                    <div className="send-funds-step3-outter-div-icon">
                      <Avatar name={receiver?.userFullName} />
                    </div>

                    <div className="send-funds-step3-outter-div-text">
                      <p className="send-funds-step3-outter-div-title">
                        {receiver?.userFullName}
                      </p>

                      <div className="send-funds-step3-outter-div-label">
                        {Number(receiver?.userKycStatus) === 3 && (
                          <>
                            <img
                              className="send-funds-step3-outter-div-label-icon"
                              src={verifiedIcon}
                              alt=""
                            />
                            <p className="send-funds-step3-outter-div-label-text">
                              {t("sendFunds.kycVerifiedUser")}{" "}
                              {receiver?.userAddress?.toLowerCase() ===
                              userAddress?.toLowerCase()
                                ? "(Self)"
                                : ""}
                            </p>
                          </>
                        )}
                        {Number(receiver?.userKycStatus) !== 3 && (
                          <p className="send-funds-step3-outter-div-label-text">
                            {t("sendFunds.unverifiedUser")}{" "}
                            {receiver?.userAddress?.toLowerCase() ===
                            userAddress?.toLowerCase()
                              ? "(Self)"
                              : ""}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="send-funds-step3-inner-text-cont">
                    <div className="send-funds-step3-inner-text-cont-col">
                      <p className="send-funds-step3-inner-text">Recipient: </p>
                      <div className="send-funds-step3-inner-footer">
                        <p className="send-funds-step3-inner-footer-text">
                          {`${receiver?.userAddress?.substring(
                            0,
                            8,
                          )}...${receiver?.userAddress?.substring(
                            receiver?.userAddress?.length - 5,
                            receiver?.userAddress?.length,
                          )}`}
                        </p>
                        <img
                          onClick={async (e) => {
                            const target = e.currentTarget;
                            if (!target) return;
                            await navigator.clipboard
                              .writeText(receiver?.userAddress)
                              .then(() => {
                                showCustomAlert(target, "Copied");
                              })
                              .catch((err) => {
                                console.error(
                                  "error while copying address: ",
                                  err,
                                );
                              });
                          }}
                          className="send-funds-step3-inner-footer-icon"
                          src={copyIcon}
                          alt="copy icon"
                        />
                      </div>
                    </div>
                    {selectedCurrency?.tokenAddress?.length > 0 && (
                      <>
                        <div className="send-funds-step3-inner-text-cont-col">
                          <p className="send-funds-step3-inner-text">
                            {t("sendFunds.tokenSelected")}:{" "}
                          </p>
                          <p className="send-funds-step3-inner-footer-text">
                            {selectedCurrency?.tokenName}
                          </p>
                        </div>

                        <div className="send-funds-step3-inner-text-cont-col">
                          <p className="send-funds-step3-inner-text">
                            {t("sendFunds.yourWalletBalance")}:{" "}
                          </p>
                          <p className="send-funds-step3-inner-footer-text">
                            {selectedCurrency.officialCurrencySymbol}
                            {Number(selectedCurrency?.balance)?.toFixed(4)}
                          </p>
                        </div>

                        <div className="send-funds-step3-inner-text-cont-col">
                          <p className="send-funds-step3-inner-text">
                            Amount to send:{" "}
                          </p>
                          <p className="send-funds-step3-inner-footer-text">
                            {selectedCurrency.officialCurrencySymbol}
                            {Number(amount) > 0
                              ? extractNumberWithCommas(amount)?.fmtNumber
                              : "0.0"}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {selectedCurrency?.tokenAddress && (
                  <div className="send-funds-step3-inner-div-cont">
                    <div className="send-funds-step3-inner-input-cont">
                      <div className="send-funds-step3-inner-input-outter">
                        <div className="send-funds-step3-inner-input-outter-cont-cont">
                          <input
                            style={
                              selectedCurrency.officialCurrencySymbol?.length >
                              1
                                ? { width: "30px" }
                                : selectedCurrency.officialCurrencySymbol
                                      ?.length > 2
                                  ? { width: "50px" }
                                  : { width: "20px" }
                            }
                            value={selectedCurrency.officialCurrencySymbol}
                            disabled={true}
                            className="send-funds-step3-inner-input-text-cont"
                          />

                          <input
                            onInput={(e) => {
                              setAmount(e.target.value);
                            }}
                            className="send-funds-step3-inner-input"
                            type="number"
                            placeholder="0.00"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {showAllCurrencies && (
          <div
            style={{ overflow: "auto", marginBottom: "30px" }}
            className="add-funds-content"
          >
            <div className="add-funds-content-header">
              <div className="add-funds-content-header-text-container">
                <img
                  onClick={() => {
                    setShowAllCurrencies(false);
                    setNewSearchContent(null);
                  }}
                  className="add-funds-popup-back-icon"
                  alt="Back Icon"
                  src={backIcon}
                />
                <p className="add-funds-search-header-text">
                  {t("header.chooseCurrency")}
                </p>
              </div>
              <img
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  setNewSearchContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                }}
                className="add-funds-popup-close-icon"
                alt="Close Icon"
                src={popupCloseIcon}
              />
            </div>
            <div className="add-funds-content-search">
              <img alt="Search Icon" src={searchIcon} />
              <input
                onInputCapture={() => {
                  selectedCurrency.isClicked = false;
                }}
                onInput={(e) => {
                  if (e.target.value === "") {
                    setNewSearchContent(null);
                  } else {
                    setNewSearchContent(
                      // eslint-disable-next-line array-callback-return
                      getSupportedCurrenciesData.filter((curr) => {
                        if (
                          curr.currencySymbol
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                        ) {
                          curr.searched = e.target.value.toLowerCase();
                          curr.nameArray = curr.currencySymbol.split("");
                          return curr;
                        }
                      }),
                    );
                  }
                }}
                className="add-funds-content-search-input"
                type="text"
                placeholder={t("placeholder.currencySearch")}
              />
            </div>
            <div className="add-funds-content-search-result">
              <div className="a-f-content-search-result-header">
                {getSupportedCurrenciesLoading && (
                  <p>{t("common.loading")}...</p>
                )}
                {!newSearchContent &&
                  getSupportedCurrenciesData
                    .filter(
                      (curr) =>
                        curr.currencySymbol &&
                        curr.officialCurrencySymbol &&
                        curr.currencyName,
                    )
                    .map((curr, idx) => (
                      <div
                        id={`crypto-curencies-${idx}`}
                        key={`crypto-curencies-${idx}`}
                        onClickCapture={() => {
                          curr["isClicked"] = true;
                          setSelectedCurrency(curr);
                        }}
                        onClick={(e) => {
                          const previouslyActiveTag =
                            document.getElementsByClassName(
                              "a-f-content-search-header-main-active",
                            );
                          if (previouslyActiveTag.length > 0) {
                            previouslyActiveTag[0].className =
                              "a-f-content-search-header-main";
                          }
                          const currentTag = document.getElementById(
                            `crypto-curencies-${idx}`,
                          );
                          currentTag.className =
                            "a-f-content-search-header-main-active";
                          handleChooseCurrencyButtonDisplay();
                        }}
                        className="a-f-content-search-header-main"
                      >
                        <div className="a-f-content-search-header-main-container">
                          <div className="a-f-content-search-header-main-content">
                            <div className="a-f-content-search-header-image">
                              <Avatar name={curr.currencySymbol} />
                            </div>
                            <div className="a-f-content-search-header-text-container">
                              <p className="a-f-content-search-header-text-header">
                                {curr.currencySymbol}
                              </p>
                              <p className="a-f-content-search-header-text-footer">
                                {curr.currencyName}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                {newSearchContent &&
                  newSearchContent.length > 0 &&
                  newSearchContent.map((curr, idx) => (
                    <div
                      id={`crypto-curencies-${idx}`}
                      key={`crypto-curencies-${idx}`}
                      onClickCapture={() => {
                        curr["isClicked"] = true;
                        setSelectedCurrency(curr);
                      }}
                      onClick={(e) => {
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "a-f-content-search-header-main-active",
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "a-f-content-search-header-main";
                        }
                        const currentTag = document.getElementById(
                          `crypto-curencies-${idx}`,
                        );
                        currentTag.className =
                          "a-f-content-search-header-main-active";
                        handleChooseCurrencyButtonDisplay();
                      }}
                      className="a-f-content-search-header-main"
                    >
                      <div className="a-f-content-search-header-main-container">
                        <div className="a-f-content-search-header-main-content">
                          <div className="a-f-content-search-header-image">
                            <Avatar name={curr.currencySymbol} />
                          </div>
                          <div className="a-f-content-search-header-text-container">
                            <p className="a-f-content-search-header-text-header">
                              {curr.nameArray?.length > 0 &&
                                curr.nameArray.map((nm, idx) => (
                                  <>
                                    {!curr.searched.includes(
                                      nm.toLowerCase(),
                                    ) && (
                                      <span
                                        key={idx}
                                        style={{
                                          color: "#B6B7C3",
                                        }}
                                      >
                                        {nm}
                                      </span>
                                    )}
                                    {curr.searched.includes(
                                      nm.toLowerCase(),
                                    ) && <span key={idx}>{nm}</span>}
                                  </>
                                ))}
                            </p>
                            <p className="a-f-content-search-header-text-footer">
                              {curr.currencyName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {showAllCurrencies && (
          <button
            id="convert-currency-popup-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                setShowAllCurrencies(false);
                setNewSearchContent(null);
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  setShowAllCurrencies(false);
                  setNewSearchContent(null);
                }
              }
            }}
            className="startup-button"
          >
            <p className="st-button-text">{t("common.proceed")}</p>
          </button>
        )}

        {!showAllCurrencies &&
          step === "3" &&
          receiver?.userAddress?.toLowerCase() !== userAddress?.toLowerCase() &&
          selectedCurrency?.tokenAddress?.length === 0 && (
            <button
              id="add-funds-popup-button"
              onClick={async (e) => {
                if (receiver?.userAddress.length > 0) {
                  setShowAllCurrencies(true);
                }
              }}
              className="startup-button-active"
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("common.proceed")}
              </p>
            </button>
          )}

        {!showAllCurrencies &&
          step === "3" &&
          receiver?.userAddress?.toLowerCase() !== userAddress?.toLowerCase() &&
          selectedCurrency?.tokenAddress?.length > 0 && (
            <button
              id="add-funds-popup-button"
              onClick={async () => {
                await handleSendFunds();
              }}
              className="startup-button-active"
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("sendFunds.sendFunds")}
              </p>
            </button>
          )}
      </div>
    </React.Fragment>
  );
};

export default SendFunds;
